// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hrsata-jobs .applicants[data-v-5586f099]{width:100vw}.hrsata-jobs .application-row-darken[data-v-5586f099]{background-color:#f5f5f5}.hrsata-jobs .subtitle[data-v-5586f099]{max-width:180px}", ""]);
// Exports
module.exports = exports;
